import { makeStyles } from '@material-ui/core';

export const useDividerStyles = makeStyles(theme => ({
  divider: {
    height: theme.spacing(0.25),
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    margin: theme.spacing(1, -1.5, 1, -1.5)
  }
}));
